class BlogSidebarWidget {

   widgetElement;

   constructor(widgetElement) {
      this.widgetElement = widgetElement;
   }

   get toggleElement() {
      return this.widgetElement.querySelector('[aria-expanded]');
   }

   get isOpen() {
      return this.toggleElement?.ariaExpanded === 'true';
   }

   open() {
      this.toggleElement.ariaExpanded = 'true';
   }

   close() {
      this.toggleElement.ariaExpanded = 'false';
   }

   initialize() {
      this.toggleElement?.addEventListener('click', (event) => {
         if (this.isOpen) {
            this.close();
         } else {
            this.open();
         }
      });
   }
}

// Initialize Sidebar Widgets
document.querySelectorAll('.blog-sidebar-widget').forEach((widgetElement) => {
   const widget = new BlogSidebarWidget(widgetElement);
   widget.initialize();
});
